module.exports = __webpack_public_path__ + "img/payment-visa-comafi.b2815407.png";